import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AlloxCommonAsyncPipe, IAlloxAsyncPipeFetch, IAlloxAsyncPipeOption } from './allox-common-async.pipe';
import { PlacementRelation, PlacementRelationService } from '@app/core';

interface IPlacementRelationPipeOption extends IAlloxAsyncPipeOption {
  name?: boolean;
}
@Pipe({
    name: 'placementRelation', pure: false,
    standalone: false
})
export class PlacementRelationPipe
  extends AlloxCommonAsyncPipe<PlacementRelation>
  implements IAlloxAsyncPipeFetch<PlacementRelation>, PipeTransform {

  constructor(private service: PlacementRelationService, changeDetectorRef: ChangeDetectorRef, router: Router) {
    super(changeDetectorRef, router);
  }

  fetchDependency(value: number) {
    return this.service.fetch(value);
  }

  makeText(value: number, obj: PlacementRelation, option?: IPlacementRelationPipeOption) {
    if (!obj) {
      return `Unknown [id: ${value}]`;
    }
    return obj.name;
  }

}
